import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	rootTitle: {
		id: 'software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate',
		defaultMessage: 'Quickstart',
		description: 'Initial title of Quickstart for devops projects',
	},
});
